

function splitUrl(url) {
  const parts = url.split(".com");
  if (parts.length > 1) {
    return parts[1];
  } else {
    return url;
  }
}

function verificaURL() {
  if (document.body.classList.contains('page-collection')) {

    const links = document.querySelectorAll('.custom-collection-link');

    const paginaURL = splitUrl(window.location.href);

    links.forEach((link) => {

      const valoreHref = link.getAttribute("href");

      let valoreHrefSplit = splitUrl(valoreHref);
      
      if (valoreHrefSplit == paginaURL) {
        link.parentNode.classList.add('active');
      }
    });
  }
}

// Esempio di invocazione della funzione
verificaURL();